define(function(require) {

  var IpsModel = require('civicsBase/ipsModel');
  return IpsModel.extend({
    urlRoot: '/delegate/civics-api/api/portal/users/register'
  });
});
